import { Injectable } from '@angular/core'
import {
  SituacaoAuxilioMoradiaDomainModel,
  SituacaoAuxilioMoradiaEnum,
  SituacaoContestacaoDomainModel,
  SituacaoContestacaoEnum,
  SituacaoMatriculaDomainModel,
  SituacaoMatriculaEnum,
  SituacaoPagamentoDomainModel,
  SituacaoPagamentoEnum,
  SituacaoTransferenciaDomainModel,
  SituacaoTransferenciaEnum,
} from '@shared/models/backend'

@Injectable({
  providedIn: 'root',
})
export class AccentService {
  getSituacaoPagamentoAccent(situacao: SituacaoPagamentoDomainModel) {
    switch (situacao?.id) {
      case SituacaoPagamentoEnum.AGUARDANDO:
        return 'gray'
      case SituacaoPagamentoEnum.ENCAMINHADO:
        return 'blue'
      case SituacaoPagamentoEnum.PAGO:
        return 'teal'
      case SituacaoPagamentoEnum.SUSPENSO:
        return 'warning'
    }
    return 'red'
  }

  getSituacaoTransferenciaAccent(situacao: SituacaoTransferenciaDomainModel) {
    switch (situacao?.id) {
      case SituacaoTransferenciaEnum.AGUARDANDO_ANUENCIA:
      case SituacaoTransferenciaEnum.AGUARDANDO_CONFIRMACAO: {
        return 'blue'
      }
      case SituacaoTransferenciaEnum.ANUENCIA_NEGADA:
      case SituacaoTransferenciaEnum.TRANSFERENCIA_NEGADA: {
        return 'red'
      }
      case SituacaoTransferenciaEnum.TRANSFERENCIA_CONCLUIDA: {
        return 'teal'
      }
      case SituacaoTransferenciaEnum.AGUARDANDO_PARECER: {
        return 'warning'
      }
      default: {
        return 'gray'
      }
    }
  }

  getSituacaoMatriculaAccent(situacao: SituacaoMatriculaDomainModel) {
    switch (situacao?.id) {
      case SituacaoMatriculaEnum.AGUARDANDO_CADASTRO: {
        return 'blue'
      }
      case SituacaoMatriculaEnum.CADASTRO_INCOMPLETO:
      case SituacaoMatriculaEnum.SUSPENSO: {
        return 'red'
      }
      case SituacaoMatriculaEnum.FERIAS:
      case SituacaoMatriculaEnum.MATRICULADO: {
        return 'teal'
      }
      case SituacaoMatriculaEnum.ATESTADO_MEDICO_MAIS_QUINZE_DIAS:
      case SituacaoMatriculaEnum.LICENCA_MATERNIDADE:
      case SituacaoMatriculaEnum.PRORROGACAO_LICENCA:
      case SituacaoMatriculaEnum.TRANCAMENTO:
      case SituacaoMatriculaEnum.TRANCAMENTO_MILITAR: {
        return 'warning'
      }
      default: {
        return 'gray'
      }
    }
  }

  getSituacaoAuxilioMoradiaAccent(situacao: SituacaoAuxilioMoradiaDomainModel) {
    switch (situacao?.id) {
      case SituacaoAuxilioMoradiaEnum.AGUARDANDO_AVALIACAO:
      case SituacaoAuxilioMoradiaEnum.AGUARDANDO_REAVALIACAO: {
        return 'blue'
      }
      case SituacaoAuxilioMoradiaEnum.SUSPENSO:
      case SituacaoAuxilioMoradiaEnum.REPROVADO: {
        return 'red'
      }
      case SituacaoAuxilioMoradiaEnum.APROVADO: {
        return 'teal'
      }
      case SituacaoAuxilioMoradiaEnum.DESISTENTE: {
        return 'warning'
      }
      default: {
        return 'gray'
      }
    }
  }

  getSituacaoContestacaoAccent(situacao: SituacaoContestacaoDomainModel) {
    switch (situacao?.id) {
      case SituacaoContestacaoEnum.PENDENTE:
        return 'blue'
      case SituacaoContestacaoEnum.APROVADA:
        return 'teal'
      case SituacaoContestacaoEnum.REPROVADA:
        return 'red'
      default:
        return 'gray'
    }
  }
}
